import React, { JSX } from "react";
import livlyLogo from "../../assets/livly2.jpg";
import livly from "../../assets/logoLC.jpeg";

export const LoginWrapper = ({ children }: { children: JSX.Element }) => {
  return (
    <div className="flex h-screen bg-white overflow-hidden">
      {/* Left panel */}
      <div className="flex flex-col w-full md:w-[52%] h-full px-8 md:px-16 py-10 justify-between">
        {/* Logo */}
        <div className="flex items-center gap-2.5">
          <img
            src={livly}
            alt="LivlyConnect logo"
            className="w-8 h-8 object-contain rounded-md"
          />
          <span className="text-lg font-bold tracking-tight text-gray-900">
            Livly<span className="text-[#5FA5F8]">Connect</span>
          </span>
        </div>

        {/* Center content */}
        <div className="max-w-sm w-full mx-auto">
          {/* Badge */}
          <span className="inline-flex items-center gap-1.5 bg-[#EBF4FF] text-[#5FA5F8] text-xs font-semibold px-3 py-1 rounded-full mb-6 tracking-wide uppercase">
            <span className="w-1.5 h-1.5 rounded-full bg-[#5FA5F8] animate-pulse" />
            Secure Access
          </span>

          <h1 className="text-3xl md:text-[2.6rem] font-extrabold text-gray-900 leading-tight">
            Welcome back
          </h1>
          <p className="mt-3 text-sm md:text-base text-gray-500 leading-relaxed">
            Sign in to manage your locks, keys, and access controls — all in one
            place.
          </p>

          {/* Divider */}
          <div className="my-8 flex items-center gap-3">
            <div className="flex-1 h-px bg-gray-200" />
            <span className="text-xs text-gray-400 font-medium">
              Continue with
            </span>
            <div className="flex-1 h-px bg-gray-200" />
          </div>
          <div className="mb-6">{children}</div>

          <p className="text-xs text-gray-400 text-center">
            By signing in you agree to our{" "}
            <a
              href="#"
              className="underline hover:text-gray-600 transition-colors"
            >
              Terms of Service
            </a>{" "}
            and{" "}
            <a
              href="#"
              className="underline hover:text-gray-600 transition-colors"
            >
              Privacy Policy
            </a>
            .
          </p>
        </div>

        {/* Footer */}
        <p className="text-xs text-gray-400 text-center">
          © {new Date().getFullYear()} Livly, Inc. All rights reserved.
        </p>
      </div>

      {/* Right panel — hero image */}
      <div
        className="xs:hidden lg:block md:w-[48%] h-full bg-cover bg-center relative"
        style={{ backgroundImage: `url(${livlyLogo})` }}
      >
        {/* Dark gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-black/10" />

        {/* Glass card at bottom */}
        <div className="absolute bottom-12 left-12 right-12 bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-8 text-white">
          <p className="text-2xl font-bold leading-snug">
            Smarter building access,
            <br />
            effortless living.
          </p>
          <p className="mt-2 text-sm text-white/70">
            Trusted by property teams across the country.
          </p>
          <div className="mt-5 flex items-center gap-3">
            <div className="flex -space-x-2">
              {["#5FA5F8", "#a78bfa", "#34d399"].map((color) => (
                <div
                  key={color}
                  className="w-8 h-8 rounded-full border-2 border-white/40"
                  style={{ background: color }}
                />
              ))}
            </div>
            <span className="text-xs text-white/70">
              Joining thousands of residents &amp; teams.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
